import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() => ({
  Container: {},
  input: {
    marginBottom: '20px',
  },
}))
